<main class="root">
  <!-- Skip to content link for accessibility -->
  <button
    class="skip-to-content"
    (click)="skipToContent()"
    aria-label="Direkt zu den Kreditangeboten springen"
    type="button"
  >
    Direkt zum Inhalt
  </button>

  <app-timeout-dialog></app-timeout-dialog>
  <div class="loader-line" *ngIf="sharedResultService.loading"></div>
  <app-header
    [eternalPage]="sharedResultService.eternalPage"
    [resultPage]="sharedResultService.resultPage"
    [loading]="sharedResultService.loading"
    [loanFilterData]="sharedResultService.dataLoan"
    [filterDataOptions]="sharedResultService.dataFilterOptions"
    [offersData]="sharedResultService.dataOffers"
    [twoApplicants]="sharedResultService.twoApplicants"
  >
  </app-header>
  <div
    class="eternalResultpage"
    *ngIf="
      sharedResultService.eternalPage &&
      sharedResultService.showDataInClosingProcess
    "
  >
    <div class="eternalResultpage__slider-wrap">
      <app-slider
        *ngIf="sharedResultService.dataInClosingProcess"
        [offersData]="sharedResultService.dataInClosingProcess"
        [eternalPage]="sharedResultService.eternalPage"
        [resultPage]="sharedResultService.resultPage"
      ></app-slider>
    </div>
  </div>
  <section
    class="resultpage"
    *ngIf="
      !sharedResultService.eternalPage ||
      (sharedResultService.eternalPage &&
        sharedResultService.showDataOffers)
    "
  >
    <app-filter
      [filterData]="sharedResultService.dataFilter"
      [filterOptionsData]="sharedResultService.dataFilterOptions"
      [offersData]="sharedResultService.dataOffers"
      (filterOutput)="postFilter()"
      (loanOutput)="postLoan()"
      [eternalPage]="sharedResultService.eternalPage"
      [resultPage]="sharedResultService.resultPage"
      [loanRequestError]="sharedResultService.loanRequestError"
      [loanRequestErrorMessage]="sharedResultService.loanRequestErrorMessage"
    ></app-filter>
    <div class="resultpage_inner-container">
      <ng-container *ngIf="+windowCouponAmount > 0">
        <app-coupon-panel></app-coupon-panel>
      </ng-container>
      <app-offer
        [loanFilterData]="sharedResultService.dataLoan"
        [filterDataOptions]="sharedResultService.dataFilterOptions"
        [offersData]="sharedResultService.dataOffers"
        [noOffersData]="sharedResultService.dataNoOffers"
        [time]="sharedResultService.time"
        [showDefaultPlaceholders]="sharedResultService.showDefaultPlaceholders"
        (filterOutput)="postFilter()"
        [eternalPage]="sharedResultService.eternalPage"
        [resultPage]="sharedResultService.resultPage"
        [twoApplicants]="sharedResultService.twoApplicants"
        [apptrackToken]="sharedResultService.apptrackToken"
      ></app-offer>
    </div>
  </section>
  <app-pixel-tracking
    *ngIf="sharedResultService.resultPage"
    [pageName]="'kredit-resultpage-thankyou'"
    [actionId]="2061"
    [siteID]="181"
  ></app-pixel-tracking>
  <app-pixel-tracking
    *ngIf="sharedResultService.resultPage"
    [pageName]="'kredit-resultpage-thankyou'"
    [actionId]="2050"
    [siteID]="180"
  ></app-pixel-tracking>
  <app-pixel-tracking
    *ngIf="
      sharedResultService.resultPage &&
      sharedResultService.matchesGoodCustomerAllocationGroup()
    "
    [pageName]="'kredit-resultpage-thankyou'"
    [actionId]="2887"
    [siteID]="181"
  ></app-pixel-tracking>
  <app-pixel-tracking
    *ngIf="
      sharedResultService.resultPage &&
      sharedResultService.matchesGoodCustomerAllocationGroup()
    "
    [pageName]="'kredit-resultpage-thankyou'"
    [actionId]="2886"
    [siteID]="180"
  ></app-pixel-tracking>
  <app-track-conversion-funnel></app-track-conversion-funnel>
</main>
<div
  class="nooffers"
  *ngIf="
    sharedResultService.eternalPage &&
    !sharedResultService.showDataOffers
  "
>
  <h1 class="nooffers__title">Keine Angebote</h1>
  <p class="nooffers__text">
    Aktuell befinden sich keine Kreditangebote in Ihrem Kreditcenter
  </p>
  <a class="nooffers__link" href="https://www.check24.at/kredit"
    >jetzt Kredite vergleichen</a
  >
</div>
